import * as React from 'react';
import translate from '../../../../locale/translate';

import { getDisplayValue, formatDate } from '../../util/StringUtil';
import ISettings from './ISettings';

import { PM } from '../../../../interfaces';

interface IProps {
    title: string,
    jobs: PM.IJob[],
    settings: ISettings,
}

const AVAILABLE_COLS = [
    'State',
    'Command',
    'Message',
    'PlannedStartTime',
    'StartTime',
    'EndTime',
];

const COL_TITLES = {
    State: translate.gettext("State"),
    Command: translate.gettext("Job command"),
    Message: translate.gettext("Message"),
    PlannedStartTime: translate.gettext("Planned start time"),
    StartTime: translate.gettext("Start time"),
    EndTime: translate.gettext("End time"),
};

const HEADER_CLASSES = {
    State: 'small col-xs-1',
    Command: 'small col-xs-2',
    Message: 'small col-xs-3',
    PlannedStartTime: 'small col-xs-2',
    StartTime: 'small col-xs-2',
    EndTime: 'small col-xs-2',
};

const COL_CLASSES = {
    Command: 'small',
    Message: 'small',
    PlannedStartTime: 'small',
    StartTime: 'small',
    EndTime: 'small',
};

const STATE_CLASSES = {
    'CREATED': 'fa-circle-thin',
    'QUEUED': 'fa-clock-o',
    'RUNNING': 'fa-cog fa-spin',
    'SUCCESSFUL': 'fa-check text-success',
    'FAILED': 'fa-exclamation-triangle text-danger',
    'CANCELLED': 'fa-times text-warning',
    'DELETED': 'fa-times text-warning'
};

const JOB_CODES = {
    1: translate.gettext('Missing mandatory parameter; see logfile for further information'),
    2: translate.gettext('Missing input file for Install or Scan command'),
    3: translate.gettext('bRCT is not startet with administrative permissions'),
    4: translate.gettext('Unexpected error, see result file and logfile for further information'),
    5: translate.gettext('One or more patches failed during installation'),
    6: translate.gettext('Another running instance of bRCT has been detected'),
    7: translate.gettext('Failed to initialize extended logging; see logfile for further information'),
    8: translate.gettext('Install succeeded, but a reboot will be required'),
    9: translate.gettext('An Error Occured, and a reboot will be required'),
    10: translate.gettext('Execution not started because a pending reboot was detected'),
    11: translate.gettext('The wsusscn2.cab is corrupted and cannot be used for the software scan')
};

export default class JobTable extends React.Component<IProps, {}> {
    static propTypes = {
        title: React.PropTypes.string.isRequired,
        jobs: React.PropTypes.array,
        settings: React.PropTypes.object.isRequired,
    };

    renderColumnHead(name: string, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            return (
                <th key={name} className={HEADER_CLASSES[name]}>{COL_TITLES[name]}</th>
            );
        }

        return;
    }

    renderState(state: string) {
        const cls = `fa fa-fw  ${STATE_CLASSES[state]}`;
        return <i className={cls} />;
    }

    renderCommand(command: string, job: PM.IJob) {
        const s = [command];

        if (job.PostAction && job.PostAction !== 'NOTHING') {
            s.push(job.PostAction);
        }

        return s.join('+');
    }

    renderMessage(message: string, job: PM.IJob) {
        const code = job.ReturnCode;

        if (code == 0) {
            return message;
        }

        return [ <p key="1">{message}</p>, <p key="2">{JOB_CODES[code]}</p> ];
    }

    renderColumn(name: string, job: PM.IJob, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            let value = job[name];

            if (name === 'PlannedStartTime' || name === 'StartTime' || name === 'EndTime') {
                if (name === 'StartTime' && !value) {
                    value = translate.gettext('Job not started');
                } else if (name === 'EndTime' && !value) {
                    value = translate.gettext('Job not finished');
                } else {
                    value = formatDate(value, 'L LT');
                }
            }

            if (name === 'Command') {
                value = this.renderCommand(value, job);
            }

            if (name === 'State') {
                value = this.renderState(value);
            }

            if (name === 'Message') {
                value = this.renderMessage(value, job);
            }

            return (
                <td key={name} className={COL_CLASSES[name]}>{value}</td>
            );
        }

        return;
    }

    renderRow(job: PM.IJob, idx: number, settings: ISettings) {
        return (
            <tr key={job.JobId}>
                {AVAILABLE_COLS.map(name => {
                    return this.renderColumn(name, job, settings);
                })}
            </tr>
        );
    }

    render() {
        let { jobs } = this.props;
        const { title, settings } = this.props;

        const key = `jobs-${title}`;
        const headers = AVAILABLE_COLS.map(name => {
            return this.renderColumnHead(name, settings);
        }).filter(header => !!header);
        const colCount = headers.length + 1;

        let rows;

        if (!jobs || !jobs.length) {
            let key = `no-jobs-${title}`;
            rows = [
                <tr key={key}>
                    <td className="muted small" colSpan={colCount}>{translate.gettext("No jobs executed")}</td>
                </tr>
            ];
        } else {
            rows = jobs.map((job: PM.IJob, idx) => {
                return this.renderRow(job, idx, settings);
            });
        }

        return (
            <div>
                <h5>{title}</h5>
                <table key={key} className="table">
                    <thead>
                        <tr>
                            {headers}
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/pm/listJobs/JobTable.tsx